import React, { useMemo } from "react";
import { FilterList, FilterListItem } from "./FilterList";
import { getHandlerCodeList } from "../../../utils/namesFormater";
import { colorHandlerCode } from "../../../utils/colorEnumFormatter";

interface HandlersFilterListProps {
  selectedHandlers: string[];
  onToggle: (handlerCode: string) => void;
  pinnedHandlers?: string[];
  onTogglePin?: (handlerCode: string) => void;
  colorByMode?: string;
  onColorByToggle?: () => void;
}

export const HandlersFilterList: React.FC<HandlersFilterListProps> = ({
  selectedHandlers,
  onToggle,
  pinnedHandlers,
  onTogglePin,
  colorByMode,
  onColorByToggle,
}) => {
  const items: FilterListItem[] = useMemo(() => {
    const handlerList = getHandlerCodeList();
    return handlerList
      .filter((handler) => handler.isGeneral)
      .map((handler) => ({
        value: handler.code,
        label: handler.name,
        color: colorHandlerCode(handler.code),
      }));
  }, []);

  return (
    <FilterList
      items={items}
      selectedValues={selectedHandlers}
      onToggle={onToggle}
      showColorIndicator={true}
      title="יצרנים"
      pinnedValues={pinnedHandlers}
      onTogglePin={onTogglePin}
      colorByMode={colorByMode}
      onColorByToggle={onColorByToggle}
      colorByValue="managing_corporation"
    />
  );
};
